// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","216":"component---src-pages-thanks-mdx","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"cbfdb8cc4528ef2e0618","216":"5fe76c38da95a6b7818b","293":"df8d1a80b3d51e43890c","522":"65f4fbd71766f5a14fd9"}[chunkId] + ".js";
};